<template lang="pug">
.card.mb-0
  .card-header
    .row.w-100
      //- .form-group.col-md-3.col-3.mb-1
      //-   b-input-group(size="sm")
      //-     b-input-group-text(slot="prepend")
      //-       i.fa.fa-search
      //-     DebounceInput(required autofocus type="text" v-model="search" :placeholder="$t('message.search_by_id')" size="sm")
      .form-group.col-md-3.col-3.mb-1
        b-input-group(size="sm")
          b-input-group-text(slot="prepend")
            span {{ $t('ui.category') }}
          b-form-select(v-model="category" @change="getBankAffList(true)" :disabled="loading" size="sm")
            option(value="") {{ $t('ui.all') }}
            option(value="BANK") {{ $tc('ui.banks', 1) }}
            option(value="EWALLET") {{ $t('ui.ewallet') }}
            option(value="CRYPTO") {{ $t('ui.crypto') }}
      .form-group.col-md-1.mb-1
        SubmitButton(
          :loading="loading"
          icon="fa fa-search"
          :text="$t('ui.search')"
          type="button"
          @click="getBankAffList(true)"
          variant="primary"
          size="sm"
        )
  .card-body
    .clusterize-scroll.table-responsive
      table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
        thead.thead-light
          tr
            th.text-center(width="3%")
              span #
            th(width="11%")
              span(:title="$t('ui.account_id')") {{ $t('ui.account_id') }}
            th(width="11%")
              span(:title="$t('ui.category')") {{ $t("ui.category") }}
            th(width="11%")
              span(:title="$t('ui.bank_id')") {{ $t("ui.bank_id") }}
            th(width="15%")
              span(:title="$t('ui.bank_name')") {{ $t("ui.bank_name") }}
            th(width="15%")
              span(:title="$t('ui.bank_acc_no')") {{ $t("ui.bank_acc_no") }}
            th(width="15%")
              span(:title="$t('ui.bank_acc_holder')") {{ $t("ui.bank_acc_holder") }}
            template(v-if="['ARS','AUD'].includes(getCurrencyCode)")
              th(width="12%")
                span(:title="['AUD'].includes(getCurrencyCode) ? $t('ui.bsb') : $t('ui.cuit')") {{ ['AUD'].includes(getCurrencyCode) ? $t('ui.bsb') : $t('ui.cuit') }}
              th(width="12%" v-if="['AUD'].includes(getCurrencyCode)")
                span(:title="$t('ui.payid')") {{ $t("ui.payid") }}
            th.text-center(width="7%")
              span(:title="$t('ui.action')") {{ $t("ui.action") }}
        tbody.clusterize-content
          tr(v-if="bankAffList.length == 0")
            td(:colspan="['ARS','AUD'].includes(getCurrencyCode) ? '10' : '8'").text-center
              span {{ $t('message.no_data_available') }}
          tr(v-for="(item, index) in bankAffList")
            td.text-center
              span(:title="index + 1") {{ index + 1 }}
            td
              span(:title="item.account_id") {{ item.account_id }}
            td
              span(:title="item.category") {{ item.category }}
            td
              span(:title="item.bank_id") {{ item.bank_id }}
            td
              span(:title="item.bank_name") {{ item.bank_name }}
            td
              span(:title="item.bank_acc_no") {{ item.bank_acc_no }}
            td
              span(:title="item.bank_acc_holder") {{ item.bank_acc_holder }}
            template(v-if="['ARS','AUD'].includes(getCurrencyCode)")
              td
                span(:title="item.remark") {{ item.remark }}
              td(v-if="['AUD'].includes(getCurrencyCode)")
                span(:title="item.remark_2") {{ item.remark_2 }}
            td.text-center
              span
                a.fa.fa-edit.btn.btn-ssm.btn-primary(href="javascript:void(0)" @click="onEdit(item)" :title="$t('ui.edit')")
  editbankaffiliate(ref="editbankaffiliate" :item="editSelectedBankAffiliate" :operatorID="operatorID" @clicked="afterEditBankAffiliate" @failed="handleFailed")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import editbankaffiliate from "@/components/affiliate/editBankAffiliate.vue";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    editbankaffiliate
  },
  data: () => ({
    loading: false,
    bankAffList: [],
    search: "",
    category: "",
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    editSelectedBankAffiliate: null,
  }),
  computed: {
    operatorID() {
      return this.$store.getters.selectedOperatorID
    },
    affiliateID() {
      return this.$store.getters.selectedAffiliateID
    },
    getCurrencyCode() {
      return this.$store.getters.currencyCode;
    }
  },
  mounted: function() {
    this.getBankAffList(true);
  },
  methods: {
    refresh() {
      this.getBankAffList(true);
    },
    redirect() {
      this.$store.dispatch("user/setSelectedOperatorID", null);
      this.$router.push('/affiliate/affiliateList')
    },
    onEdit(e) {
      this.editSelectedBankAffiliate = e;
      this.$refs.editbankaffiliate.$refs.editBankAffiliate.show();
    },
    afterEditBankAffiliate: function(item) {
      this.getBankAffList();
      this.$helpers.showDialog(this.$t("ui.combine.edit_bank_affiliate"), this.$t("message.success"), "success");
    },
    getBankAffList: function() {
      let url = config.bankAccountListAffUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        account_id: this.affiliateID,
        category: this.category
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.bankAffList = response.data.dt;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>